export const getIsAppStandalone = (): boolean => {
  return window.top === window.self;
};
